module.exports = __webpack_public_path__ + "img/video-m-2.d70f86ab.png";